import React, { useEffect, useState } from 'react';
import { Box, Button, IconButton, Typography, useMediaQuery } from '@mui/material';
import AddIcon from '../../common/assests/addmsglogo.png';
import EditIcon from '../../common/assests/editicon.png';
import DeleteIconImg from '../../common/assests/deleticon.png';
import TestingImg from '../../common/assests/gridimg3.png';
import PeopleIcon from '../../common/assests/people.svg';
import Paginations from '../../common/pagination/Paginations';
import ForumModal from './ForumModal'; 
import EyeIcon from '../../common/assests/eyeicon.png';
import { useNavigate } from 'react-router-dom';
import ModrationDetail from './detailview/ModrationDetail';
import { useSelector } from 'react-redux';
import { createForumApi, deleteForumApi, getAllContentModerationForum, postDeleteApi, updateFourmApi } from '../../api';
import ReyLeaf from "../../common/assests/reyleafLogo.svg";
import Loader from '../../common/loader/Loader';
import { toast } from 'react-toastify';
import configuration from '../../config/Config';


const ContentModration = () => {

  const token = useSelector((state) => state?.user?.user?.token);
  const navigate=useNavigate()
  const [open, setOpen] = useState(false);
  const [editingData, setEditingData] = useState(null);
  const isSmallScreen = useMediaQuery('(max-width:480px)');
  const [contentModrationData, setContentModrationData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [loading, setLoading] = useState(false);
  const [change, setChange] = useState(false);
 

  const handleContentModeration=async()=>{
    try {
      setLoading(true)
      const response = await getAllContentModerationForum({token,currentPage})
      setContentModrationData(response?.data)
      setCurrentPage(response?.currentPage)
      setTotalPages(response?.totalPages)
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.log("error",error);
    }
  }

  useEffect(() => {
    handleContentModeration();
  }, [currentPage,change])
  

  const handleClickOpen = (data) => {
    setEditingData(data||null);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = async (forumData, id) => {
    try {
      if (id) {
        if(!forumData.title || !forumData.description){
          toast.warning("Title and description required")
          return
        }
        const response = await updateFourmApi({ token, forumData, id });
        toast.success(response?.message);
        handleClose()
      } else {
        // Create new forum
        if(!forumData.title || !forumData.description || ! forumData.picture){
          toast.warning("Image,title and description required")
          return
        }
        const response = await createForumApi({ token, forumData });
        toast.success(response?.message);
        setEditingData(null);
        handleClose()
      }
      setChange(!change);
    } catch (error) {
      toast.error(error?.message||error?.error);
      console.error("Error saving forum", error);
    }
  };


  const handleDelete =async(id) => {
    const isConfirmed = window.confirm(
      "Are you sure, you want to Delete this Forum?"
    );
    if (!isConfirmed) {
      return;
    }
    try {
      const response = await deleteForumApi({token,id})
      // console.log("delete froum post",response);
      toast.success(response?.message)
      setChange(!change)
      
    } catch (error) {
      if (error?.status === 500) {
        toast.error("Some error occured");
      } else {
        toast.error(error?.message||error?.error);
      }
      console.log("error", error);
    }
  };


  const handleViewDetails = (event) => {
    navigate("/content-moderation/details", {
      state: { event}
    });
  };


  const handlePageChange = (page) => {
    setLoading(true);
    setCurrentPage(page);
  };

  return (
    <div>

      {loading ? (
          <Loader variant="cardList" />
      ):(
    
        <Box
        sx={{
          borderRadius: '24px',
          background: '#FFF',
          boxShadow: '3px 2px 20px 0px rgba(0, 0, 0, 0.04)',
          padding: '16px',
          width: '100%',
          maxWidth: '1460px',
          margin: 'auto',
          boxSizing: 'border-box',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 1,
          }}
        >
          <Typography
            sx={{
              fontSize: '20px',
              fontWeight: '500',
              color: '#362B24',
              fontFamily: 'Heebo',
            }}
          >
            All Forums
          </Typography>

          <Button
            onClick={() => handleClickOpen(null)}
            sx={{
              borderRadius: '29px',
              background: 'linear-gradient(180deg, #065F46 0%, #0D7B5C 100%)',
              boxShadow: '1px 2px 30px 0px rgba(0, 0, 0, 0.06)',
              width: '235px',
              height: '58px',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
              textTransform: 'none',
              fontSize: isSmallScreen ? '12px' : '16px',
              '@media (max-width:600px)': {
                width: '200px',
                height: '50px',
              },
            }}
          >
            <img src={AddIcon} alt="Add" style={{ height: '24px', width: '24px', marginRight: '3px' }} />
            Create New Forum
          </Button>
        </Box>

        <Box sx={{ mt: 3 }}>

          {contentModrationData?.length>0 ? (
            contentModrationData.map((item) => (
              <Box
                key={item?._id}
                sx={{
                  borderRadius: '22px',
                  background: '#FFF',
                  boxShadow: '1px 2px 30px 0px rgba(0, 0, 0, 0.06)',
                  maxWidth: '1380px',
                  height: 'auto',
                  minHeight: '116px',
                  flexShrink: 0,
                  marginBottom: '16px',
                  marginTop: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '16px',
                  boxSizing: 'border-box',
                  flexDirection: { xs: 'column', sm: 'row' },
                }}
              >
                {/* Left Side: Image and Event Details */}
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: { xs: 'column', sm: 'row' },
                    gap: { xs: '20px', sm: '0px' },
                    width: '100%',
                  }}
                >
                  <img
                     src={item?.picture ? `${configuration.cdnFront}/${item?.picture}`:ReyLeaf}
                      alt="Event-img"
                    style={{
                      borderRadius: '13px',
                      marginRight: '16px',
                      width: '91px',
                      height: '96px',
                      objectFit: 'cover',
                    }}
                  />
                  <Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                      <Typography
                        sx={{
                          fontSize: '17px',
                          fontWeight: '600',
                          color: '#362B24',
                          fontFamily: 'Heebo',
                        }}
                      >
                        {item?.title||"N/A"}
                      </Typography>
                    </Box>
  
                    <Typography sx={{ fontFamily: 'Heebo', color: '#065F46', fontWeight: '400', display: 'flex', gap: '5px', fontSize: '12px',alignItems:'center' }}>
                      <img src={PeopleIcon} alt='img' style={{ width: '17px', height: '17px' }} />
                      <span>{item?.members ? item?.members?.length:"0"} Members</span>
                    </Typography>
  
                    <Typography
                    mt={1}
                      sx={{
                        fontSize: '14px',
                        color: '#7D6F6F',
                        fontFamily: 'Heebo',
                        maxWidth: '900px',
                        width: '100%',
                        opacity: '0.6',
                        
                      }}
                    >
                       {item?.description && item.description.length > 150 
                    ? `${item.description.substring(0, 250)}...`
                    : item?.description || 'No description available'}

                    </Typography>
                  </Box>
                </Box>
  
                {/* Right Side: Action Icons */}
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <IconButton onClick={()=>handleViewDetails(item)}>
                    <img
                      src={EyeIcon}
                      alt="View"
                      style={{ height: '44px', width: '45px', marginTop: '3px' }}
                    />
                  </IconButton>
                  <IconButton onClick={() => handleClickOpen(item)}>
                    <img src={EditIcon} alt="Edit" />
                  </IconButton>
                  
                  <IconButton onClick={() => handleDelete(item?._id)}>
                    <img src={DeleteIconImg} alt="Delete" />
                  </IconButton>
                </Box>
              </Box>
            ))

          ):(
            <div style={{textAlign:'center'}}>
              "No Data FOund"
            </div>
          )}
        </Box>

        <Paginations
            totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            disabled={loading}
          />

      </Box>

      )}

    

      {/* Modal Component */}
      <ForumModal
        open={open}
        handleClose={handleClose}
        handleSave={handleSave}
        editingData={editingData}
      />
      
    </div>
  );
};

export default ContentModration;
